import { message } from 'antd';
import { ErrorResponse } from '../model/response';

export default function processError(error: any, defaultMessage?: string) {
  console.error(error);
  if (error?.response?.data?.message) {
    const errorResponse = error.response.data as ErrorResponse;
    message.error(errorResponse.message).then();
    return;
  }
  message.error(defaultMessage || 'Đã có lỗi xảy ra').then();
}
